<template>
  <div class="index-wrap">
    <div class="index-header">
      <div class="user-info">
        <div class="avatar">
          <img
            v-if="user"
            :src="user.avatar || require('@/assets/default-avatar.png')"
            alt="头像"
          />
        </div>
        <div v-if="user" class="nick-name">{{ user.nickname }}</div>
      </div>
    </div>
    <!-- <div class="week-info" @click="$router.push('/week')">周奖榜单</div> -->
    <!-- <div class="index-logo">
      <img :src="require('@/assets/img/top-icon.png')" />
    </div> -->
    <div class="index-label">
      <img :src="require('@/assets/img/label-icon.png')" />
    </div>
    <div class="menu-wrap">
      <van-row type="flex" justify="space-between" align="center" :gutter="10">
        <van-col>
          <div class="menu-item bg-1" @click="$router.push('/rule')"></div>
        </van-col>
        <van-col>
          <div class="menu-item-center bg-2" @click="toCompetition"></div>
        </van-col>
        <van-col>
          <div class="menu-item bg-3" @click="$router.push('/print')"></div>
        </van-col>
        <!-- <van-col>
          <div class="menu-item bg-1" @click="toCompetition"></div>
          <div class="menu-item bg-2" @click="$router.push('/reward')"></div>
          <div
            class="menu-item bg-3"
            @click="$router.push('/errors?type=1')"
          ></div>
        </van-col>
        <van-col>
          <div
            class="menu-item bg-4"
            @click="$router.push('/credential/list')"
          ></div>
          <div class="menu-item bg-5" @click="$router.push('/result')"></div>
          <div class="menu-item bg-6" @click="$router.push('/rank')"></div>
        </van-col> -->
      </van-row>
    </div>
    <div class="info-wrap">
      <van-row type="flex" justify="space-between">
        <van-col span="6">
          <div class="info-label">主办单位：</div>
        </van-col>
        <van-col span="18">
          <div class="info-text">山西省科学技术协会</div>
        </van-col>
      </van-row>
      <van-row type="flex" justify="space-between">
        <van-col span="6">
          <div class="info-label">支持单位：</div>
        </van-col>
        <van-col span="18">
          <div class="info-text">山西省全民科学素质工作责任单位</div>
        </van-col>
      </van-row>
      <van-row type="flex" justify="space-between">
        <van-col span="6">
          <div class="info-label">媒体协作：</div>
        </van-col>
        <van-col span="18">
          <div class="info-text">山西广播电视台健康之声广播</div>
        </van-col>
      </van-row>
      <van-row type="flex" justify="space-between">
        <van-col span="6">
          <div class="info-label">技术支持：</div>
        </van-col>
        <van-col span="18">
          <div class="info-text">中科数创(北京)数字传媒有限公司</div>
        </van-col>
      </van-row>
    </div>
    <!-- <div class="bottom-label">
      <img :src="require('@/assets/img/bottom-label.png')" />
    </div> -->
    <van-dialog
      v-model="areaDialog"
      class="area-dialog"
      title="用户参赛信息"
      confirm-button-text="确定"
      :show-cancel-button="true"
      cancel-button-text="关闭"
      :before-close="submitArea"
    >
      <div class="area-dialog_content">
        <van-field
          class="area-field"
          v-model="userName"
          maxlength="30"
          error-message=""
          placeholder="真实姓名"
        />
        <van-field
          class="area-field"
          v-model="fieldValue"
          is-link
          readonly
          label="所在地区"
          placeholder=""
          input-align="right"
          center
          @click="pickArea"
        />
        <van-field
          label="所属社区、村"
          readonly
          :border="false"
          style="padding-bottom: 0"
        />
        <van-field
          class="area-field"
          v-model="village"
          label=""
          maxlength="50"
          error-message=""
          placeholder="请填写全称，没有可填写为“无”"
        />
        <van-field
          label="注册单位名称"
          readonly
          :border="false"
          style="padding-bottom: 0"
        />
        <van-field
          class="area-field"
          v-model="unit"
          label=""
          maxlength="50"
          error-message=""
          placeholder="请填写全称，没有可填写为“无”"
        />
        <van-field
          class="area-field"
          v-model="crowdRender"
          is-link
          readonly
          label="人群类别"
          placeholder=""
          input-align="right"
          center
          @click="showCrowdPicker = true"
        />
        <van-field
          class="area-field"
          v-model="ageRender"
          is-link
          readonly
          label="您的年龄"
          placeholder=""
          input-align="right"
          center
          @click="showAgePicker = true"
        />
        <!-- <van-field
          class="area-field"
          v-model="genderRender"
          is-link
          readonly
          label="性别（选填）"
          placeholder=""
          input-align="right"
          center
          @click="showGenderPicker = true"
        /> -->
        <van-field
          class="area-field"
          v-model="phone"
          type="tel"
          maxlength="11"
          error-message=""
          placeholder="请输入参赛手机号"
        />
        <van-field
          class="area-field"
          v-model="sms"
          center
          type="digit"
          maxlength="4"
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              round
              @click="sendVerifyCode"
              :disabled="sended"
              >{{ sended ? countTime : "获取验证码" }}</van-button
            >
          </template>
        </van-field>
      </div>
    </van-dialog>
    <van-dialog v-model="userLocationDialog" class="custom-dialog">
      <div class="custom-dialog-main">
        <div class="custom-dialog-title">提示</div>
        <div class="custom-dialog-content">
          很遗憾，您当前的位置为【{{
            provinceName
          }}】，不在竞赛区域（山西省）内，无法参加本次活动
        </div>
      </div>
    </van-dialog>
    <van-popup v-model="showAreaPicker" round position="bottom">
      <van-cascader
        v-model="areaValue"
        title="请选择所在地区"
        :options="options"
        active-color="#1989fa"
        @close="showAreaPicker = false"
        @change="onChange"
        @finish="onFinish"
        :field-names="fieldNames"
      />
    </van-popup>
    <van-popup v-model="showCrowdPicker" round position="bottom">
      <van-picker
        title="人群类别"
        show-toolbar
        :columns="crowds"
        @confirm="crowdConfirm"
        @cancel="showCrowdPicker = false"
      />
    </van-popup>
    <van-popup v-model="showAgePicker" round position="bottom">
      <van-picker
        title="请选择年龄区间"
        show-toolbar
        :columns="ages"
        @confirm="ageConfirm"
        @cancel="showAgePicker = false"
      />
    </van-popup>
    <!-- <van-popup v-model="showGenderPicker" round position="bottom">
      <van-picker
        title="请选择性别"
        show-toolbar
        :columns="genders"
        @confirm="genderConfirm"
        @cancel="showGenderPicker = false"
      />
    </van-popup> -->
    <div v-if="time > 0 && showCountDown" class="time-count">
      <p>距离开赛还有</p>
      <van-count-down :time="time" @finish="countDownFinish">
        <template #default="timeData">
          <span class="block">{{ timeData.days }}</span>
          <span class="colon">天</span>
          <span class="block">{{ timeData.hours }}</span>
          <span class="colon">时</span>
          <span class="block">{{ timeData.minutes }}</span>
          <span class="colon">分</span>
          <span class="block">{{ timeData.seconds }}</span>
          <span class="colon">秒</span>
        </template>
      </van-count-down>
    </div>
  </div>
</template>
<script>
// import { getLocation } from "@/utils/share";
import { Dialog } from "vant";
export default {
  data() {
    return {
      areaDialog: false,
      userLocationDialog: false,
      cityCode: "",
      countyCode: "",
      townCode: "",
      provinceCode: "",
      provinceName: "",
      userName: "",
      cityList: [],
      countyList: [],
      phone: "",
      sms: "",
      showAreaPicker: false,
      areaValue: "",
      options: [],
      fieldValue: "请选择",

      fieldNames: {
        text: "name",
        value: "code",
        children: "children",
      },
      countTime: 300,
      sended: false,
      items: [],
      ageRender: "请选择",
      ages: [
        { key: 1, text: "18岁以下" },
        { key: 2, text: "18-29岁" },
        { key: 3, text: "30-39岁" },
        { key: 4, text: "40-49岁" },
        { key: 5, text: "50-59岁" },
        { key: 6, text: "60-69岁" },
        { key: 7, text: "69岁以上" },
      ],
      crowds: [
        { key: 1, text: "青少年" },
        { key: 2, text: "农民" },
        { key: 3, text: "产业工人" },
        { key: 4, text: "老年人" },
        { key: 5, text: "领导干部和公务员" },
        { key: 6, text: "其他" },
      ],
      // genders: [
      //   { key: 1, text: "男" },
      //   { key: 2, text: "女" },
      // ],
      showAgePicker: false,
      age: "",
      // company: "",
      showCrowdPicker: false,
      crowdRender: "请选择",
      crowd: "",
      // genderRender: "请选择",
      // gender: "",
      // showGenderPicker: false,
      unit: "",
      village: "",
      time: 1756656000000 - Number(new Date().getTime()),
      showCountDown: true,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    // 跳转竞赛答题
    async toCompetition() {
      if (new Date().getTime() < 1756656000000) {
        this.$notify({
          type: "danger",
          message: "活动未开始",
          duration: 2000,
        });
      } else {
        if (this.user && this.user.nickname) {
          if (
            this.user.province_code &&
            this.user.province_code != "0" &&
            this.user.city_code &&
            this.user.city_code != "0"
          ) {
            this.$router.push("/question");
          } else {
            this.areaDialog = true;
            // getLocation(async (longitude, latitude, msg) => {
            //   if (longitude && latitude) {
            //     try {
            //       const res = await this.$axios.post(`/User/getLocal`, {
            //         longitude: longitude,
            //         latitude: latitude,
            //       });
            //       // if (
            //       //   res.data.province == "山西省" ||
            //       //   res.data.province == "北京市"
            //       // ) {
            //       if (res.data.province == "山西省") {
            //         this.areaDialog = true;
            //       } else {
            //         this.provinceName = res.data.province;
            //         this.userLocationDialog = true;
            //       }
            //       console.log(res);
            //     } catch (error) {
            //       this.$notify({
            //         type: "danger",
            //         message: error.errorMsg || "定位失败！",
            //         duration: 2000,
            //       });
            //       console.log(error);
            //     }
            //   } else {
            //     console.log(msg);
            //     this.$notify({
            //       type: "danger",
            //       message: "获取位置信息失败,请确保您的手机定位权限已开启",
            //       duration: 2000,
            //     });
            //   }
            // });
          }
        } else {
          this.$notify({
            type: "danger",
            message: "认证失败，请确定您已授权",
            duration: 2000,
          });
        }
      }
    },
    pickArea() {
      this.loadArea(1, "").then(() => {
        this.options = this.items;
        this.showAreaPicker = true;
      });
    },
    async loadArea(level, code) {
      try {
        const res = await this.$axios.post(`/Region/getRegionList`, {
          level: level,
          code: code,
        });
        if (level == 2 || level == 3 || level == 1) {
          this.items = (res.data ?? []).map((item) => {
            item.children = [];
            return item;
          });
        } else {
          this.items = res.data ?? [];
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || "获取地区信息失败！",
          duration: 2000,
        });
        return [];
      }
    },
    async submitArea(action, done) {
      if (action == "cancel") {
        done();
      } else {
        Dialog.confirm({
          title: "提示",
          message: "用户参赛信息提交后将无法修改，是否确认提交",
          confirmButtonColor: "#3a5bfc",
        })
          .then(async () => {
            if (!this.userName.trim()) {
              this.$toast.fail("请输入姓名");
              done(false);
            } else if (
              !this.cityCode.trim() ||
              !this.countyCode.trim() ||
              !this.townCode.trim()
            ) {
              this.$toast.fail("请选择地区信息");
              done(false);
            } else if (!this.village.trim()) {
              this.$toast.fail("所属社区、村不能为空");
              done(false);
            } else if (!this.unit.trim()) {
              this.$toast.fail("注册单位名称不能为空");
              done(false);
            } else if (!this.phone.trim()) {
              this.$toast.fail("请输入手机号");
              done(false);
            } else if (
              !/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.phone.trim())
            ) {
              this.$toast.fail("请输入正确格式的手机号");
              done(false);
            } else if (!this.sms.trim()) {
              this.$toast.fail("请输入验证码");
              done(false);
            } else {
              try {
                await this.$axios.post(`/User/updateRegion`, {
                  name: this.userName,
                  province: this.provinceCode,
                  city: this.cityCode,
                  county: this.countyCode,
                  town: this.townCode,
                  age: this.age,
                  mobile: this.phone,
                  verify_code: this.sms,
                  people: this.crowd,
                  // gender: this.gender,
                  village: this.village,
                  unit: this.unit,
                });
                this.user.province_code = this.provinceCode;
                this.user.city_code = this.cityCode;
                this.user.county_code = this.countyCode;
                this.user.town_code = this.townCode;
                this.user.village = this.village;
                this.user.unit = this.unit;
                this.$store.commit("SET_USER", this.user);
                done();
                this.$notify({
                  type: "success",
                  message: "提交成功",
                  duration: 2000,
                });
                // this.$router.push("/question");
              } catch (error) {
                this.$notify({
                  type: "danger",
                  message: error.errorMsg || "保存用户信息失败！",
                  duration: 2000,
                });
                done(false);
                console.log(error);
              }
            }
          })
          .catch(() => {
            done(false);
          });
      }
    },
    onChange({ tabIndex, selectedOptions, value }) {
      if (tabIndex == 0) {
        this.loadArea(2, value).then(() => {
          selectedOptions[tabIndex].children = this.items;
        });
      } else if (tabIndex == 1 && value) {
        this.loadArea(3, value).then(() => {
          selectedOptions[tabIndex].children = this.items;
        });
      } else if (tabIndex == 2 && value) {
        this.loadArea(4, value).then(() => {
          selectedOptions[tabIndex].children = this.items;
        });
      }
    },
    onFinish({ selectedOptions }) {
      this.showAreaPicker = false;
      this.provinceCode = selectedOptions[0].code;
      this.cityCode = selectedOptions[1].code;
      this.countyCode = selectedOptions[2].code;
      this.townCode = selectedOptions[3].code;
      this.fieldValue = selectedOptions.map((item) => item.name).join(" ");
    },
    ageConfirm(value) {
      this.age = value.key;
      this.ageRender = value.text;
      this.showAgePicker = false;
    },
    crowdConfirm(value) {
      this.crowd = value.key;
      this.crowdRender = value.text;
      this.showCrowdPicker = false;
    },
    // genderConfirm(value) {
    //   this.gender = value.key;
    //   this.genderRender = value.text;
    //   this.showGenderPicker = false;
    // },
    async sendVerifyCode() {
      if (!this.phone.trim()) {
        this.$toast.fail("请输入手机号");
        return false;
      } else if (!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.phone.trim())) {
        this.$toast.fail("请输入正确格式的手机号");
        return false;
      } else {
        try {
          await this.$axios.post(`/User/sendSms`, {
            mobile: this.phone,
          });
          this.countTime = 300;
          this.sended = true;
          const timer = setInterval(() => {
            this.countTime--;
            if (this.countTime <= 0) {
              this.sended = false;
              clearInterval(timer);
            }
          }, 1000);
        } catch (error) {
          this.$notify({
            type: "danger",
            message: error.errorMsg || "发送失败",
            duration: 2000,
          });
          console.log(error);
        }
      }
    },
    countDownFinish() {
      this.showCountDown = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.index-wrap {
  position: relative;
  @include index-bg;

  .index-label {
    margin-top: 80px;
    text-align: center;

    img {
      width: 344px;
      vertical-align: top;
    }
  }

  .index-header {
    position: absolute;
    top: 30px;

    .user-info {
      display: flex;
      align-items: center;
      max-width: 120px;
      padding: 5px 22px;
      background: rgba(145, 55, 249, 0.7);
      border-radius: 0 24px 24px 0;

      .avatar {
        flex-shrink: 0;
        width: 39px;
        height: 39px;
        margin-right: 10px;
        overflow: hidden;
        vertical-align: top;
        border-radius: 50%;

        img {
          width: 100%;
          vertical-align: top;
        }
      }

      .nick-name {
        max-width: 100px;
        max-height: 35px;
        font-size: 14px;
        line-height: 35px;
        color: #fff;
        @include textoverflow(1);
      }
    }
  }

  .menu-wrap {
    padding: 0 20px;

    .menu-item {
      width: 92px;
      height: 92px;
      cursor: pointer;

      &-center {
        width: 111px;
        height: 111px;
        cursor: pointer;
      }
    }

    @for $i from 1 through 3 {
      .bg-#{$i} {
        background: url("~@/assets/img/bg-#{$i}.png") no-repeat top center/100%;
      }
    }
  }

  .info-wrap {
    padding: 10px 40px 50px;
    font-size: 12px;
    line-height: 20px;
    color: #fff;

    .van-row {
      align-items: baseline;
    }

    .info-label {
      position: relative;
      font-size: 12px;
      font-weight: 600;
      line-height: 20px;
    }

    .info-text {
      text-align: justify;
    }
  }

  // .bottom-label {
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   z-index: 1;
  //   img {
  //     width: 100%;
  //     vertical-align: top;
  //   }
  // }

  ::v-deep .van-dialog__footer::after {
    display: none;
  }

  .area-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 7px;
    margin-bottom: 12px;
    font-size: 13px;
    line-height: 18px;
    color: #666;
    cursor: pointer;
    border: 1px solid #efefef;
    border-radius: 3px 3px 3px 3px;
  }

  .area-disabled {
    color: #999;
    background: #efefef;
  }

  ::v-deep .area-dialog {
    width: 318px;

    .van-dialog__header {
      padding-top: 20px;
      font-size: 20px;
      font-weight: 500;
      line-height: 25px;
      color: #333;
    }

    .area-dialog_content {
      .area-field {
        .van-field__control {
          color: #3b60fc;
        }

        .van-field__control--right {
          overflow: hidden;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
        }
      }

      .van-cell__right-icon {
        color: #3b60fc;
      }
    }

    .van-dialog__footer {
      $border-color: #3683f9;

      justify-content: space-between;
      padding: 20px 30px 31px;

      &.van-hairline--top::after {
        border-color: #fff;
      }

      .van-hairline--left::after {
        border-color: #fff;
      }

      .van-button {
        height: 37px;
        font-size: 15px;
        color: #fff;
        background: linear-gradient(to right, #43a3f5, #3a5bfc);
        border-radius: 64px;
      }

      .van-dialog__cancel {
        margin-right: 18px;
      }
    }
  }

  .custom-dialog {
    .custom-dialog-main {
      padding: 20px 20px 50px;

      .custom-dialog-title {
        font-size: 20px;
        font-weight: 500;
        line-height: 25px;
        color: #333;
        text-align: center;
      }

      .custom-dialog-content {
        margin-top: 20px;
        font-size: 15px;
        line-height: 25px;
        color: #333;
        text-align: justify;
      }
    }
  }

  .time-count {
    position: absolute;
    top: 90px;
    right: 0;
    left: 0;
    width: 310px;
    height: 100px;
    margin: auto;
    font-size: 14px;
    color: #fff;
    text-align: center;
    background: rgba(0, 0, 0, 0.58);
    border: 1px solid #fff;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.4) 0 2px 6px 0;

    p {
      margin: 20px 0;
    }

    .block {
      display: inline-block;
      padding: 5px 3px;
      margin: 0 6px;
      background-color: #fff;
      border: 0.5px solid #333;
      border-radius: 4px;
    }

    .colon {
      color: #fff;
    }
  }
}
</style>
